import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export function CTAButton({
  text,
  className = ''
}: CTAButtonProps) {
  return <a href="https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS" className={`inline-block px-8 py-4 bg-gradient-to-r from-teal-500 to-blue-600 hover:from-teal-600 hover:to-blue-700 text-white font-medium rounded-lg shadow-md transition duration-300 text-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50 text-center mx-auto ${className}`} data-id="element-215">
      {text}
    </a>;
}